import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getCurrentUserProfile, upsertCurrentUserProfile } from "../../services/supabase/companyAdminService";

function OnboardingAdminLimitado() {
  const {
    currentCompany,
    user,
    completeUserProfile,
    refreshWorkspace,
  } = useAuth();
  const [fullName, setFullName] = useState("");
  const [documentId, setDocumentId] = useState("");
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLocalError("");

    if (!fullName.trim()) {
      setLocalError("El nombre y apellido es obligatorio.");
      return;
    }

    if (!documentId.trim()) {
      setLocalError("El documento es obligatorio.");
      return;
    }

    if (!phone.trim()) {
      setLocalError("El telefono es obligatorio.");
      return;
    }

    setSubmitting(true);

    try {
      await upsertCurrentUserProfile({
        fullName,
        documentId,
        phone,
      });

      const nextProfile = await getCurrentUserProfile();
      completeUserProfile(nextProfile);
      await refreshWorkspace(user);
    } catch (error) {
      setLocalError(error.message || "No se pudo completar tu perfil.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.panel}>
        <div style={styles.brand}>Primer acceso</div>
        <h1 style={styles.title}>Completa tus datos para activar el acceso</h1>
        <p style={styles.subtitle}>
          Tu cuenta ya fue reconocida dentro de{" "}
          <strong>{currentCompany?.name || "la empresa activa"}</strong>. Antes de entrar al
          panel necesitamos registrar tus datos personales para identificarte en permisos,
          sucursales y turnos.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Nombre y apellido
            <input
              type="text"
              value={fullName}
              onChange={(event) => setFullName(event.target.value)}
              style={styles.input}
              placeholder="Ej: Juan Perez"
              disabled={submitting}
            />
          </label>

          <label style={styles.label}>
            Documento
            <input
              type="text"
              value={documentId}
              onChange={(event) => setDocumentId(event.target.value)}
              style={styles.input}
              placeholder="Ej: DNI 30111222"
              disabled={submitting}
            />
          </label>

          <label style={styles.label}>
            Telefono
            <input
              type="text"
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              style={styles.input}
              placeholder="Ej: +54 11 4444 4444"
              disabled={submitting}
            />
          </label>

          <label style={styles.label}>
            Email
            <input
              type="email"
              value={user?.email || ""}
              style={styles.input}
              disabled
            />
          </label>

          {localError && <div style={styles.errorBanner}>{localError}</div>}

          <button type="submit" style={styles.primaryButton} disabled={submitting}>
            {submitting ? "Guardando..." : "Activar acceso"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    backgroundColor: "#f8fafc",
  },
  panel: {
    width: "100%",
    maxWidth: "560px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    padding: "32px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 48px rgba(15, 23, 42, 0.1)",
    display: "grid",
    gap: "16px",
  },
  brand: {
    display: "inline-flex",
    width: "fit-content",
    padding: "8px 14px",
    borderRadius: "999px",
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    fontWeight: 700,
  },
  title: {
    margin: 0,
    color: "#0f172a",
  },
  subtitle: {
    margin: 0,
    color: "#475569",
    lineHeight: 1.6,
  },
  form: {
    display: "grid",
    gap: "14px",
  },
  label: {
    display: "grid",
    gap: "8px",
    color: "#334155",
    fontWeight: 600,
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "12px",
    border: "1px solid #cbd5e1",
    padding: "12px 14px",
    fontSize: "15px",
    color: "#0f172a",
    backgroundColor: "#ffffff",
  },
  errorBanner: {
    borderRadius: "12px",
    border: "1px solid #fecaca",
    backgroundColor: "#fff1f2",
    color: "#be123c",
    padding: "12px 14px",
  },
  primaryButton: {
    border: "none",
    borderRadius: "12px",
    padding: "13px 16px",
    backgroundColor: "#0f172a",
    color: "#ffffff",
    fontWeight: 700,
    cursor: "pointer",
  },
};

export default OnboardingAdminLimitado;
